import React from 'react'
import {
  Typography,
  Stack,
  List,
  ListItemText,
  Box,
  useTheme
} from '@mui/material'

import { ConnectedDotsIcon } from '../../components/Icons/ConnectedDotsIcon'
import { TransitionButton } from '../../components/Buttons/TransitionButton'
import { BulletListItem } from '../../components/DisplayHelpers/BulletListItem'
import { QualifyingDeviceComponentProps, SUPPORT_URL } from './types'

export const QualifyingDeviceComponent: React.FC<
  QualifyingDeviceComponentProps
> = ({ handleClick }) => {
  const theme = useTheme()
  return (
    <Box sx={{ maxWidth: 400 }}>
      <Typography
        component="h1"
        variant="h5"
        align="center"
        color="text.primary"
        gutterBottom
      >
        To get the most out of your Paceline Card, take note of the following:
      </Typography>
      <div style={{ textAlign: 'center' }}>
        <ConnectedDotsIcon sx={{ height: '1em', width: '2em' }} />
      </div>

      <Stack spacing={2}>
        <List sx={{ pl: 3.5, pt: 0 }}>
          <BulletListItem disableGutters>
            <ListItemText primary="A Qualifying Device is recommended (Apple iPhone with iOS 14.0 or greater)" />
          </BulletListItem>
          <BulletListItem disableGutters>
            <ListItemText primary="An Android or Web based app is not currently available" />
          </BulletListItem>
          <BulletListItem disableGutters>
            <ListItemText
              primary={
                <Typography>
                  A Supported Wearable such as an Apple Watch, Fitbit wearable,
                  or Garmin watch is required to record eHR Minutes and earn
                  your Paceline Streak. For a list of currently supported
                  wearable devices please visit our{' '}
                  <a
                    href={SUPPORT_URL}
                    target="__blank"
                    style={{
                      textDecoration: 'none',
                      color: theme.palette.secondary.main
                    }}
                  >
                    Help Center
                  </a>
                  .
                </Typography>
              }
            />
          </BulletListItem>
        </List>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
          }}
        >
          <TransitionButton
            text="Next"
            onClick={handleClick}
            style={{ width: '8rem' }}
          />
        </Box>
      </Stack>
    </Box>
  )
}
